<body>
    <div class="w-100 vertical-center">
        <div class="mx-auto">
            <div class="row">
                <div class="col-4 vertical-center">
                    <p class=" icon mx-auto w-50 text-center">
                        ):
                    </p>
                   
                </div>
                <div class="col-8  vertical-center ">
                    <div class="mt-2 col-12 mx-auto">
                        <h1 class="responsive-font" >
                            Error 404:
                            
                        </h1>
                        <p>De pagina dat u probeert te zoeken werd niet gevonden.</p>
                        <button [routerLink]="['',previousRoute,'tools']" class="btn  btn-success mt-1">HOMEPAGINA</button>
                    </div>
                    
                    
                </div>
            </div>
            
            
        </div>
        
    </div>
</body>

